import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppInput from '../../../../common/AppInput';
import { Grid, Paper } from '@material-ui/core';
import { schema } from './validation/schema';

import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  inputContainer: {
    '& > div > div': {
      width: '100%',
    },
  },
  paperContainer: {
    maxWidth: 350,
  },
  form: {
    width: '100%',
  },
}));

const Password = ({ ...props }) => {
  const classes = useStyles();
  const [password, setPassword] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [confirmationPassword, setConfirmationPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [matchError, setMatchError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [matchSuccess, setMatchSuccess] = useState(false);

  const { onClick, modifiable, onFocus, internalValidation } = props;

  const handleClick = (event) => {
    onClick(event.target.value);
    resetPasswords();
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const handleOldPasswordChange = (event) => {
    setOldPassword(event.target.value);
  };
  const handleConfirmationPasswordChange = (event) => {
    setConfirmationPassword(event.target.value);
  };
  const handleValidation = () => {
    if ('error' in schema.validate({ password: password })) {
      setPasswordError(true);
      setErrorMessage(schema.validate({ password: password }).error.message);
      setPasswordSuccess(false);
    } else {
      setPasswordError(false);
      setErrorMessage('');
      setPasswordSuccess(true);
    }
  };
  const matchPasswords = () => {
    if (
      password !== confirmationPassword ||
      password === '' ||
      confirmationPassword === ''
    ) {
      setMatchError(true);
      setMatchSuccess(false);
    } else {
      setMatchError(false);
      setMatchSuccess(true);
    }
  };

  const resetPasswords = () => {
    setPassword('');
    setOldPassword('');
    setConfirmationPassword('');
  };

  useEffect(() => {
    onFocus({ password, confirmationPassword, oldPassword });
  }, [password, confirmationPassword, oldPassword]);

  useEffect(() => {
    if (internalValidation) {
      handleValidation();
      matchPasswords();
    }
  }, [internalValidation]);

  return (
    <Grid container spacing={2} className={classes.inputContainer}>
      {!modifiable && (
        <Grid item md={6} xs={12}>
          <AppInput
            name="password"
            type="password"
            value="*****"
            label="Contraseña"
            inputAdornment=""
            onClick={handleClick}
            showTogglePassword={false}
          />
        </Grid>
      )}
      {modifiable && (
        <form className={classes.form}>
          <Paper elevation={0} className={classes.paperContainer}>
            <Grid item md={12} xs={12}>
              <AppInput
                name="old-password"
                type="password"
                autoComplete="old-password"
                value={oldPassword}
                label="Contraseña actual*"
                inputAdornment=""
                error={''}
                errorMessage={''}
                success={passwordSuccess}
                onChange={handleOldPasswordChange}
                onBlur={handleValidation}
                onClick={() => false}
                showTogglePassword={true}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <AppInput
                name="new-password"
                type="password"
                autoComplete="new-password"
                value={password}
                label="Nueva contraseña*"
                inputAdornment=""
                error={passwordError}
                errorMessage={errorMessage}
                success={passwordSuccess}
                onChange={handlePasswordChange}
                onBlur={handleValidation}
                onClick={() => false}
                showTogglePassword={true}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <AppInput
                name="confirm-newpassword"
                type="password"
                autoComplete="confirm-new-password"
                value={confirmationPassword}
                label="Confirmar contraseña*"
                inputAdornment=""
                error={matchError}
                errorMessage={'Contraseñas no coinciden'}
                success={matchSuccess}
                onChange={handleConfirmationPasswordChange}
                onBlur={matchPasswords}
                onClick={() => false}
                showTogglePassword={true}
              />
            </Grid>
          </Paper>
        </form>
      )}
    </Grid>
  );
};

Password.propTypes = {
  modifiable: PropTypes.bool,
  internalValidation: PropTypes.bool,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
};

export default Password;
